import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CacheService } from '../shared/services/cache.service';
import { Observable, of } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { LoaderService } from '../shared/services/loader.service';

export const CacheInterceptor: HttpInterceptorFn = (req, next) => {
	const cacheService = inject(CacheService);
	const loaderService = inject(LoaderService);

	if (req.method !== 'GET' || !cacheService.isCacheable(req.urlWithParams)) {
		return next(req);
	}

	const cachedResponse = cacheService.get(req.urlWithParams);
	if (cachedResponse) {
		return of(cachedResponse.clone());
	} else {
		loaderService.show();
	}

	return next(req).pipe(
		tap((event) => {
			if (event instanceof HttpResponse) {
				cacheService.set(req.urlWithParams, event.clone());
			}
		}),
		finalize(() => loaderService.hide())
	);
};
